import { getRelativeTime } from '@thoughtspot/date-format-util';
import _ from 'lodash';
import { useEffect, useState } from 'react';
export const useDataHooks = (useGetOrgsListQuery, isRefreshed, orgListInput, setIsLoading) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { data: orgsList, error: orgsListError, loading: orgsListLoading, refetch: refreshOrgList, } = useGetOrgsListQuery(orgListInput);
    useEffect(() => {
        if (isRefreshed) {
            refreshOrgList({ data: orgListInput });
        }
    }, [isRefreshed]);
    useEffect(() => {
        try {
            if (orgsList) {
                const orgData = _.cloneDeep(orgsList.Data.orgs);
                const countOfGroupsByOrg = orgsList.Data.countOfGroupsByOrg || {};
                const countOfUsersByOrg = orgsList.Data.countOfUsersByOrg || {};
                const parseData = orgData.map((org) => {
                    const { orgId, orgName, enabled, description, allGroupUserId, defaultAdminUserGroupId, author, authorName, created, } = org;
                    return {
                        id: orgId,
                        orgName: {
                            text: orgName || '',
                        },
                        orgDesc: {
                            text: description,
                        },
                        users: {
                            text: countOfUsersByOrg[orgId] || 0,
                        },
                        groups: {
                            text: countOfGroupsByOrg[orgId] || 0,
                        },
                        author: [
                            {
                                name: authorName || 'Author',
                                src: '',
                            },
                        ],
                        created: {
                            text: getRelativeTime(created),
                        },
                    };
                });
                setData(parseData);
                setLoading(false);
                setIsLoading(false);
            }
        }
        catch (err) {
            setError(true);
            setLoading(false);
            setIsLoading(false);
        }
    }, [orgsList]);
    return {
        data,
        loading,
        error,
        isLastBatch: orgsList?.Data?.isLastBatch || false,
    };
};
//# sourceMappingURL=useDataHook.js.map